import React from "react";

export function ServicesTriad() {
  const IconGraph = (p) => (<svg viewBox="0 0 24 24" {...p}><path fill="currentColor" d="M3 19h18v2H3zM7 10h2v7H7zm4-4h2v11h-2zm4 6h2v5h-2z"/></svg>);
  const IconBolt = (p) => (<svg viewBox="0 0 24 24" {...p}><path fill="currentColor" d="M13 2 3 14h7v8l11-14h-8z"/></svg>);
  const IconShield = (p) => (<svg viewBox="0 0 24 24" {...p}><path fill="currentColor" d="M12 2 4 5v6c0 5 3.4 9.7 8 11 4.6-1.3 8-6 8-11V5z"/></svg>);
  const IconCheck = (p) => (<svg viewBox="0 0 24 24" {...p}><path fill="currentColor" d="M9.55 17.1 4.9 12.45l1.4-1.4 3.25 3.25 7.2-7.2 1.4 1.4z"/></svg>);

  const items = [
    { title: "Gestion publicitaire", bullets: ["SP / SB / SD / DSP", "Ciblage mots-clés & ASIN", "Contrôle ACOS & TACOS"], icon: <IconGraph className="h-5 w-5 text-orange-300" /> },
    { title: "Expansion & Scale", bullets: ["SEO listings + Store", "Lancement EU & multi-pays", "Promotions & deals"], icon: <IconBolt className="h-5 w-5 text-orange-300" /> },
    { title: "Ops & Catalog Health", bullets: ["Buy Box, prix, variations", "Suppressions & conformité", "Stocks & alertes rupture"], icon: <IconShield className="h-5 w-5 text-orange-300" /> },
  ];

  return (
    <section id="services" className="mx-auto max-w-6xl px-4 py-12 md:py-16">
      <h2 className="mb-6 text-2xl font-semibold text-white">Services Amazon</h2>
      <div className="grid gap-6 md:grid-cols-3">
        {items.map((it) => (
          <div key={it.title} className="rounded-2xl border border-white/10 bg-white/[0.03] p-6">
            <div className="mb-3 inline-flex items-center gap-2">{it.icon}
              <h3 className="text-lg font-semibold text-white">{it.title}</h3>
            </div>
            <ul className="space-y-2">
              {it.bullets.map((b, i) => (
                <li key={i} className="flex items-start gap-3 text-sm text-neutral-300">
                  <IconCheck className="mt-0.5 h-4 w-4 text-emerald-400" /><span>{b}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}